export const SWAGGER_URL = 'http://104.248.149.72';
const API_PREFIX = '/api';
const AUTH_PREFIX = '/auth';

const Api = {
  LOGIN: API_PREFIX + AUTH_PREFIX + '/login',
  REGISTER: API_PREFIX + AUTH_PREFIX + '/register',
  FORGOT_PASSWORD: API_PREFIX + AUTH_PREFIX + '/forgot',
  CONTENT: API_PREFIX + '/contents',
  CONTENT_DELETE: API_PREFIX + '/content/:id',
  CONTENT_ADD_LINK: API_PREFIX + '/content/url/add',
  CONTENT_ADD_FILES: API_PREFIX + '/contents/upload',
  PLAYLISTS: API_PREFIX + '/playlists',
  PLAYLIST: API_PREFIX + '/playlist/:id',
  PLAYLIST_CONTENTS: API_PREFIX + '/playlist/:id/contents',
  PLAYLIST_CREATE: API_PREFIX + '/playlist/add',
  PLAYLIST_RENAME: API_PREFIX + '/playlist/:id/rename',
  PLAYLIST_COPY: API_PREFIX + '/playlist/:id/copy',
  EDIT_PLAYLIST: API_PREFIX + '/playlist/:id',
  CALENDAR: API_PREFIX + '/calendar/:id',
  CALENDAR_CREATE: API_PREFIX + '/calendar',
  CALENDAR_RENAME: API_PREFIX + '/calendar/:id/rename',
  CALENDAR_DELETE_DEVICE: API_PREFIX + '/calendar/:calendarId/player/:playerId',
  CALENDAR_ADD_DEVICE: API_PREFIX + '/calendar/:id/players',
  CALENDAR_ADD_PLAYLIST:
    API_PREFIX + '/calendar/:calendarId/playlist/:playlistId',
  CALENDAR_PLAYLIST: API_PREFIX + '/calendar/:calendarId/playlist/:guid',
  CALENDARS: API_PREFIX + '/calendars',
  DEVICE: API_PREFIX + '/player/:id',
  DEVICE_ADD: API_PREFIX + '/player/add',
  DEVICE_EDIT: API_PREFIX + '/player/:id/edit',
  DEVICE_DEACTIVATE: API_PREFIX + '/player/:id/deactivate',
  DEVICE_SCREENSHOT: API_PREFIX + '/player/:id/screenshot',
  DEVICES: API_PREFIX + '/players',
  LOGS: API_PREFIX + '/player/:id/logs',
  SETTINGS: '/api/settings',
  SETTINGS_MAIN: '/api/settings/main',
  SETTINGS_PASSWORD: '/api/settings/password',
  SETUP: '/api/setup',
  SETUP_COMPANY: '/api/setup/company',
  SETUP_SERVER: '/api/setup/server',
  SETUP_SMTP: '/api/setup/smtp',
  SETUP_SMTP_CHECK: '/api/setup/smtp/check',
  LICENSE: '/api/license',
};

export default Api;
